import { ADMIN_DEBUGGER_LS_KEY } from '@pesto/utils/constants/shared-local-storage-keys';

export const isDebuggerEnabled = localStorage.getItem(ADMIN_DEBUGGER_LS_KEY) === 'true';
